{
  "links" : {
    "triggerLinksDescription" : "Links de acionamento Habilitar Você para inserir links Mensagens SMS internas e Gmail, que Habilitar Você para rastrear atividades específicas do cliente e ocorrências de gatilho com base Ativado Quando o Link é clicado.",
    "enterName" : "Inserir nome",
    "enterLinkURL" : "Insira URL para fazer link",
    "save" : "Arquivar",
    "cancel" : "Cancelar",
    "delete" : "Excluir",
    "aboutToDeleteLink" : "Você está Sobre para excluir o Link de gatilho ${deleteRowName} . O Link apagado não pode ser restaurado. Tem certeza de que deseja continuar?",
    "noTriggerLinksFound" : "Nenhum link de acionamento encontrado",
    "getStartedByAddingNewTriggerLinks" : "Via adicionando novos Links de acionamento",
    "newTriggerLink" : "Novo Linkgatilho",
    "searchNoMatch" : "Seu Pesquisar não correspondeu a nenhum Link de gatilho .",
    "link" : "Link",
    "addLink" : "Adicionar Link",
    "linkURL" : "URL do link",
    "name" : "Nome",
    "pleaseEnterNonEmptyLinkName" : "Digite um nome de Link não vazio",
    "pleaseEnterURL" : "Insira o URL",
    "actions" : "atividades",
    "linkKey" : "Chave de Link",
    "keyCopied" : "Chave copiado"
  }
}
